module.exports = __webpack_public_path__ + "media/images/member_keep-db5a9ed6a782ced1f3cbecd37311cd6b.svg";